(ns manatee.admin.pending-items.handlers
  "Event handlers for the Admin. Pending Items tab."
  (:require
   [ajax.edn :as edn]
   [clojure.set :as set]
   [kee-frame.core :as kf]
   [manatee.admin.pending-items.app-db :as db]
   [manatee.annotation.handlers :as annotation-handlers]
   [manatee.components.notifications.handlers :as notifications]
   [re-frame.core :as rf]
   [taoensso.timbre :as log]))

(rf/reg-event-fx
 ::fetch-pending-items
 (fn [{:keys [db]} [_ user]]
   (let [old-user (:user (db/get-pending-items db))]
     (merge
      {:db (cond-> db
             true (db/set-pending-items nil)
             (not= user old-user) (db/update-pending-items-to-reassign (constantly #{})))}
      (when user
        {:http-xhrio {:method :get
                      :uri (kf/path-for [:api/pending-item-groups :user-id (:id user)])
                      :response-format (edn/edn-response-format)
                      :on-success [::fetch-pending-items-success user]
                      :on-failure [::fetch-pending-items-failure]}
         :dispatch [::annotation-handlers/set-loading? true]})))))

(rf/reg-event-fx
 ::fetch-pending-items-success
 (fn [{:keys [db]} [_ user items]]
   {:db (-> db
            (db/set-pending-items {:user user
                                   :items items})
            (db/set-user-to-assign-to nil)
            (db/update-pending-items-to-reassign set/intersection
                                                 (set (map :item-group-id items))))
    :dispatch [::annotation-handlers/set-loading? false]}))

(rf/reg-event-fx
 ::fetch-pending-items-failure
 (fn [_ [_ info]]
   (log/error "Error loading pending items" {:info info})
   {:dispatch-n [[::notifications/add-alert :main
                  {:message "Unable to load pending items. Try again."
                   :type :error}
                  :auto-dismiss? false]
                 [::annotation-handlers/set-loading? false]]}))

(rf/reg-event-db
 ::pending-item-to-reassign-checked
 (fn [db [_ item-group-id checked?]]
   (db/update-pending-items-to-reassign db
                                        (if checked? conj disj)
                                        item-group-id)))

(rf/reg-event-db
 ::assign-to
 (fn [db [_ user]]
   (db/set-user-to-assign-to db user)))

(rf/reg-event-fx
 ::reassign-pending-items
 (fn [_ [_ user item-group-ids assignee]]
   {:http-xhrio {:method :delete
                 :uri (kf/path-for [:api/pending-item-groups :user-id (:id user)])
                 :params {:item-group-ids item-group-ids, :assignee (if (= assignee :sys) nil (:id assignee))}
                 :format (edn/edn-request-format)
                 :response-format (edn/edn-response-format)
                 :on-success [::reassign-pending-items-success user]
                 :on-failure [::reassign-pending-items-failure]}
    :dispatch [::annotation-handlers/set-loading? true]}))

(rf/reg-event-fx
 ::reassign-pending-items-success
 (fn [_ [_ user]]
   {:dispatch-n [[::notifications/add-alert :main
                  {:message "Pending items reassigned successfully."
                   :type :info}
                  :auto-dismiss? true]
                 [::fetch-pending-items user]]}))

(rf/reg-event-fx
 ::reassign-pending-items-failure
 (fn [_ [_ info]]
   (log/error "Error loading pending items" {:info info})
   {:dispatch-n [[::notifications/add-alert :main
                  {:message "Unable to reassign pending items. Reload the list and try again."
                   :type :error}
                  :auto-dismiss? false]
                 [::annotation-handlers/set-loading? false]]}))
